import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../../components/header/header";
import Footer from "../../../components/footer/footer";
import BannerComponent from "../../../components/bannerComponent/bannerComponent";
import ButtonLinkComponent from "../../../components/buttonLink/buttonLink";
import "./specialist.css";

const SpecialistComponent = () => {
  const { t } = useTranslation();

  function openBooking() {
    const BOOKING_URL =
      "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?ismsaljsauthenabled=true&RefID=VMA_SPECIALIST";

    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }

  const heroData = {
    title: t("VIRTUAL_MEDICAL_SERVICES_TITLE"),
    text: t("VIRTUAL_MEDICAL_SERVICES_DESC"),
    className: "specialistHeroBanner",
    chipText: t("VMA_HERO_CHIP"),
  };

  const healthcareCareCoordinationSuite = [
    {
      serviceName: t("CONTACT_CENTER_PATIENTS"),
      img: "/img/openart-image_WJoUryst_1716397116164_raw 1.jpg",
      description: t("CONTACT_CENTER_PATIENTS_DESC"),
    },
    {
      serviceName: t("SCHEDULING_CENTER"),
      img: "/img/openart-image_KrItEU0K_1716397766100_raw 1.jpg",
      description: t("SCHEDULING_CENTER_DESC"),
    },
    {
      serviceName: t("DIAGNOSTIC_REVIEWS_COMMUNICATIONS"),
      img: "/img/realistic-scene-with-health-worker-taking-care-elderly-patient 1.jpg",
      description: t("DIAGNOSTIC_REVIEWS_COMMUNICATIONS_DESC"),
    },
    {
      serviceName: t("TREATMENT_MANAGEMENT"),
      img: "/img/scene-from-care-job-with-young-child-patient-being-take-care 1.jpg",
      description: t("TREATMENT_MANAGEMENT_DESC"),
    },
    {
      serviceName: t("RISKS_MANAGEMENT"),
      img: "/img/risk management 1.jpg",
      description: t("RISKS_MANAGEMENT_DESC"),
    },
    {
      serviceName: t("EMR_MAINTENANCE"),
      img: "/img/Designer 1.jpg",
      description: t("EMR_MAINTENANCE_DESC"),
    },
    {
      serviceName: t("AUDITING"),
      img: "/img/auddit 1.jpg",
      description: t("AUDITING_DESC"),
    },
    {
      serviceName: t("BILLING_COORDINATION"),
      img: "/img/billing 1.jpg",
      description: t("BILLING_COORDINATION_DESC"),
    },
    {
      serviceName: t("FINANCIAL_COVERAGE_PRECHECKS"),
      img: "/img/paying-bills-planning-budget-acquire-wealth-generated-by-ai 1.jpg",
      description: t("FINANCIAL_COVERAGE_PRECHECKS_DESC"),
    },
  ];

  function SpecialistCard({ img, title, text }) {
    return (
      <article className="specialistCard">
        <div className="specialistCardMedia">
          <img src={img} alt={title} />
        </div>

        <div className="specialistCardContent">
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </article>
    );
  }

  return (
    <>
      <Header />

      <main className="specialistPage">
        <section className="specialistHero specialistHeroFull">
          <div className="specialistHeroBannerFull">
            <BannerComponent
              translateTitle={heroData.title}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("HIRE_VMA")}
              chipText={heroData.chipText}
              onClick={openBooking}
              headingTag="h1"
            />
          </div>
        </section>

       <section className="specialistServices">
        <div className="specialistServicesWrap">
            <div className="specialistSectionIntro">
                <h2>{t("SPECIALIST_SERVICES_SECTION_TITLE") || "Áreas de soporte especializadas"}</h2>
                <p>
                {t("SPECIALIST_SERVICES_SECTION_DESC") ||
                    "Descubra los servicios virtuales que pueden fortalecer la coordinación, administración y seguimiento de su práctica médica."}
                </p>
            </div>

          <div className="specialistServicesGrid">
            {healthcareCareCoordinationSuite.map((data, index) => (
              <SpecialistCard
                key={index}
                title={data.serviceName}
                text={data.description}
                img={data.img}
              />
            ))}
          </div>
        </div>
        </section>

        <section className="specialistCta">
            <div className="specialistCtaInner">
                <div className="specialistCtaContent">
                <h2>{t("READY_ENHANCE_PRACTICE")}</h2>

                <div className="specialistCtaText">
                    <p>{t("CONTACT_US_FOR_MORE_INFO_1")}</p>
                    <p>{t("CONTACT_US_FOR_MORE_INFO_2")}</p>
                </div>
            </div>
            <ButtonLinkComponent
              translateButton={t("HIRE_VMA")}
              url={
                "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=VMA_SPECIALIST"
              }
              blank={true}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default SpecialistComponent;